<mat-select 
    [formControl]="formControl" 
    [formlyAttributes]="field"
    [matTooltip]="matTooltipTxt ? matTooltipTxt : this.props.label"
    matTooltipPosition="right"
    [matTooltipDisabled]="false"
>
    <mat-option *ngIf="!props.required" matTooltip="-Aucune sélection-" matTooltipPosition="right">-Aucune sélection-</mat-option>
    <mat-option *ngFor="let option of props.options" [value]="option.value" [matTooltip]="option.label" matTooltipPosition="right">
        {{option.label}}
    </mat-option>
</mat-select>